import { Button, Container, Row } from "react-bootstrap";
import SocialHandle from "../SocialHandle/SocialHandle";
import "./HeroSection.css";
import pdf from "../../../Resource/Resume of Shihabun Shakib.pdf";

export default function HeroSection() {
  return (
    <Container>
      <Row className="heroSection justify-content-center align-items-center">
        <div className="col-md-10 col-12 col-sm-12 heroContent">
          <h5 className="highlight">Hello! I am</h5>
          <h1 className="name">SHIHABUN SHAKIB</h1>
          <h2 className="highlight">Front End Developer </h2>
          <Row className="p-0 m-0 title">
            <p>Web Developer</p>
            <p>Programmer</p>
          </Row>

          <a target="_blank" rel="noreferrer" href={pdf} download>
            <Button className="resumeBtn px-5 py-2">Resume</Button>
          </a>
        </div>

        <div className="socialMediaContainer col-md-2 col-sm-12 col-12 d-flex align-items-center justify-content-end">
          <SocialHandle />
        </div>
      </Row>
    </Container>
  );
}
